import { ICaseCloseRepository } from '../../application/ports/outbound/ICaseCloseRepository';
import { CaseClosureReason } from '../../application/domain/entities/CaseClosureReason';
import { HttpClient } from '@/shared/infra/http/HttpClient';
import { CaseClosureReasonResponseDto } from './dto/res/CaseClosureReasonResponseDto';
import { CloseCaseRequestDto } from './dto/req/CloseCaseRequestDto';
import { CaseCloseMapper } from './mappers/CaseCloseMapper';
import { EMPLOYEE_CONTINUES_TO_WORK_AFTER_FNC } from '../../application/validators/close-case.schema';

export class ApiCaseCloseRepository implements ICaseCloseRepository {
    constructor(private readonly httpClient: HttpClient) { }

    async fetchCaseClosureReasons(everifyCaseId: string): Promise<CaseClosureReason[]> {
        const response = await this.httpClient.get<CaseClosureReasonResponseDto>(
            `e-verify/case-closure-reason/${everifyCaseId}`
        );

        return response.data.case_closure_reasons.map(CaseCloseMapper.toDomain);
    }

    async closeCase(
        everifyCaseId: string,
        reasonCode: string,
        reasonDescription: string
    ): Promise<void> {
        const isEmployeeContinueToWork = reasonCode === EMPLOYEE_CONTINUES_TO_WORK_AFTER_FNC;
        const requestDto: CloseCaseRequestDto = {
          closeCaseReasonCode: reasonCode,
          closeCaseReasonDescription: isEmployeeContinueToWork ? '' : reasonDescription,
          ...(isEmployeeContinueToWork && {
            currentlyEmployedReasonDescription: reasonDescription,
          }),
        };

        await this.httpClient.post(`e-verify/close-case/${everifyCaseId}`, requestDto);
    }
}
